import "./OwnerServices.module.css";
import MainNavigation from "@/reusable_sections/Header";
import YourInvestmentLifecycle from "./sections/YourInvestmentLifecycle";
import FinancialTransparency from "./sections/FinancialTransparency";
import ManagementInquiry from "./sections/ManagementInquiry";
import SiteFooter from "@/reusable_sections/Footer";
export default function OwnerServicesPage() {
  return <div>
      <MainNavigation />
      <YourInvestmentLifecycle />
      <FinancialTransparency />
      <ManagementInquiry />
      <SiteFooter />
    </div>;
}